const actionByStatus = {
  review: {
    key: "delete",
    icon: "mdi-delete",
  },
  active: {
    key: "deactivate",
    icon: "mdi-account-off-outline",
    nextStatus: "deleted",
  },
  deleted: {
    key: "reactivate",
    icon: "mdi-account-check-outline",
    nextStatus: "active",
  },
};

export function getGlnAction(item) {
  return item && actionByStatus[item.status]
    ? actionByStatus[item.status]
    : null;
}

const statusOrder = {
  review: 0,
  active: 1,
  deleted: 2,
};

export function sortGlnsByStatus(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.slice().sort((left, right) => {
    const leftOrder = Object.prototype.hasOwnProperty.call(statusOrder, left.status)
      ? statusOrder[left.status]
      : 3;
    const rightOrder = Object.prototype.hasOwnProperty.call(statusOrder, right.status)
      ? statusOrder[right.status]
      : 3;

    return leftOrder - rightOrder;
  });
}
